export default "__VITE_ASSET__f01a47c2__"